export class ApiError extends Error {
    constructor(message: string, cause?: unknown) {
        super(message);
        this.cause = cause;
        this.name = 'API Error';
        this.stack = new Error().stack;
    }
}
